import { createBrowserRouter } from "react-router";

import { PageNotFound } from "@digital-services/shell";

import { SignedOutPage } from "@account/pages/SignedOutPage";
import { SigningOutPage } from "@account/pages/SigningOutPage";
import ApplicationsPage from "@application/pages/ApplicationsPage";
import { AuditLogPage } from "@audit-log/pages/AuditLogPage";
import { HomePage } from "@home/pages/HomePage";
import OrganizationAdmins from "@organization/components/adminAssociation/OrganizationAdmins";
import { ResourcesTab } from "@organization/components/adminAssociation/ResourcesTab";
import { OrganizationApplications } from "@organization/components/applicationAssociation/OrganizationApplications";
import OrganizationDetailsComponent from "@organization/components/OrganizationDetailsComponent";
import { ParentOrganizationTab } from "@organization/components/ParentOrganizationTab";
import OrganizationDetailPage from "@organization/pages/OrganizationDetailPage";
import { OrganizationsOverviewPage } from "@organization/pages/OverviewPage";
import { ResourcesPage } from "@resource/pages/ResourcesPage";

import { Root } from "./root";

export const router = createBrowserRouter([
  {
    path: "sign-out",
    element: <SigningOutPage />
  },
  {
    path: "signedout",
    element: <SignedOutPage />
  },
  {
    path: "/",
    element: <Root />,
    children: [
      {
        index: true, // <-- match on parent, i.e. "/"
        element: <HomePage />
      },
      {
        path: "clientApp/home",
        element: <HomePage />
      },
      {
        path: "*",
        element: <PageNotFound />
      },
      {
        path: "organizations",
        element: <OrganizationsOverviewPage />
      },
      {
        path: "organizations/:organizationId",
        element: <OrganizationDetailPage />,
        children: [
          {
            path: "",
            element: <OrganizationDetailsComponent />
          },
          {
            path: "applications",
            element: <OrganizationApplications />
          },
          {
            path: "admins",
            element: <OrganizationAdmins />
          },
          {
            path: "parent-organization",
            element: <ParentOrganizationTab />
          },
          {
            path: "resources",
            element: <ResourcesTab />
          }
        ]
      },
      {
        path: "applications",
        element: <ApplicationsPage />
      },
      {
        path: "resources",
        element: <ResourcesPage />
      },
      {
        path: "resources/:resourceId",
        element: <ResourcesPage />
      },
      // Tech Note
      // There is no ability yet to inject here useUserContext() and conditionally build list of routes.
      // As result end user can manually type a URL in address bar, but will be redirected to UnAuthorized user if user role = Reader
      {
        path: "audit-log",
        element: <AuditLogPage />
      }
    ]
  }
]);
